import { CustomSerializer } from './router.serializer';
import { NgModule } from '@angular/core';
import {
  NavigationActionTiming,
  StoreRouterConnectingModule,
  DEFAULT_ROUTER_FEATURENAME,
  routerReducer,
} from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { provideAppRouterPaths } from './router.provider';
import { CoreRouterEffects } from './+state';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    StoreModule.forFeature(DEFAULT_ROUTER_FEATURENAME, routerReducer),
    // Connects RouterModule with StoreModule, uses MinimalRouterStateSerializer by default
    StoreRouterConnectingModule.forRoot({
      serializer: CustomSerializer,
      navigationActionTiming: NavigationActionTiming.PostActivation,
    }),
    EffectsModule.forFeature([CoreRouterEffects]),
  ],
  providers: [],
  exports: [StoreModule, StoreRouterConnectingModule],
})
export class CoreStoreRouterModule {}
